const offconvase={
    TITLE: "ارتقا به نسخه طلایی",
    DESCRIPTION:"کاربر گرامی،<br>در نسخه رایگان برنامه فقط چند آموزش ابتدایی جهت آشنایی با کیفیت آموزش ها، قابل نمایش است.<br>برای مشاهده آموزش ها می توانید از دو روش زیر اقدام نمایید",
    BUY:"خرید ",
    BUY_ALL:"خرید همه آموزش های این دوره با تخفیف"

}

export default offconvase